import styled from '@emotion/styled';

const Wrapper = styled.div<{ compact?: boolean }>`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  height: 100%;
  width: 100%;
  font-weight: ${({ theme }) => theme.typography.fontWeightRegular};

  /* Explicitly set font-family for all SVG text elements */
  text {
    font-family: 'Faktum', system-ui;
  }

  .bar, .bar-label {
    pointer-events: none;
  }

  .compact :is(.bar, .bar-label) {
    cursor: pointer;
    pointer-events: auto;
  }

  .compact .cartesian-grid-line {
    transform: translateY(0.5px);
  }

  .cartesian-grid-line:is(:first-of-type, :last-of-type) {
    display: none;
  }

  .compact.universe-chart .cartesian-grid-line:nth-of-type(2) {
    display: none;
  }

  .bar-label.highlight * {
    font-weight: 600;
  }

  .bar {
    opacity: var(--chart-non-highlighted-opacity);
    transition: opacity 150ms ease;
  }

  .bar.highlight {
    opacity: 1;
  }

  .compact.chart {
    width: auto !important;
    height: auto !important;
  }
`;

export default { Wrapper };
